export const LOAD_HIGH = 15;
export const LOAD_MEDIUM = 8;

export const navInfo = {
  role: "CSC Admin",
  initials: "JG",
  name: "J. Gregor",
};

export const viewTabs = [
  { id: "projects", label: "By Project" },
  { id: "inspectors", label: "By Inspector" },
];

export const inspectorDirectory = [
  {
    id: "rm",
    name: "Ronald A. Milley II",
    initials: "RM",
    avatarClass: "rm",
    subtitle: "Senior Inspector ·  Residential & Commercial",
    workload: 18,
    availability: "available",
    loadLevel: "high",
    isUnavailable: false,
  },
  {
    id: "ts",
    name: "Tom Sullivan",
    initials: "TS",
    avatarClass: "ts",
    subtitle: "Inspector ·  Commercial Focus",
    workload: 11,
    availability: "away",
    loadLevel: "med",
    isUnavailable: true,
  },
  {
    id: "jm",
    name: "Jason McLaughlin",
    initials: "JM",
    avatarClass: "jm",
    subtitle: "Inspector ·  Residential Focus",
    workload: 9,
    availability: "available",
    loadLevel: "low",
    isUnavailable: false,
  },
  {
    id: "mb",
    name: "Marie Bouchard",
    initials: "MB",
    avatarClass: "mb",
    subtitle: "Inspector ·  Residential & Commercial",
    workload: 9,
    availability: "available",
    loadLevel: "low",
    isUnavailable: false,
  },
];

export const inspectorCards = [
  {
    id: "rm",
    name: "Ronald A. Milley II",
    initials: "RM",
    avatarClass: "rm",
    meta: "Senior Inspector ·  Residential & Commercial",
    status: "available",
    loadText: "18 projects",
    loadClass: "high",
    notesTone: "danger",
    notes: "High load - consider redistributing before adding new projects",
    projects: [
      { name: "Aroma Joes - Portland", role: "primary" },
      { name: "15 Washington - Waterville", role: "primary" },
      { name: "Wells Starbucks", role: "primary" },
      { name: "Kennebunk Commons", role: "coverage" },
    ],
  },
  {
    id: "ts",
    name: "Tom Sullivan",
    initials: "TS",
    avatarClass: "ts",
    meta: "Inspector ·  Commercial Focus",
    status: "away",
    loadText: "11 projects",
    loadClass: "med",
    notesTone: "warn",
    notes:
      "On vacation Apr 1-7. Any inspections during this period require coverage.",
    projects: [
      { name: "Harbor View Mixed-Use", role: "primary" },
      { name: "15 Washington - Waterville", role: "coverage" },
    ],
  },
  {
    id: "jm",
    name: "Jason McLaughlin",
    initials: "JM",
    avatarClass: "jm",
    meta: "Inspector ·  Residential Focus",
    status: "available",
    loadText: "9 projects",
    loadClass: "low",
    notesTone: "good",
    notes: "Capacity available - good candidate for new project assignments",
    projects: [
      { name: "Harbor View Mixed-Use", role: "primary" },
      { name: "Kennebunk Commons", role: "coverage" },
    ],
  },
  {
    id: "mb",
    name: "Marie Bouchard",
    initials: "MB",
    avatarClass: "mb",
    meta: "Inspector ·  Residential & Commercial",
    status: "available",
    loadText: "9 projects",
    loadClass: "low",
    notesTone: "good",
    notes: "Capacity available - good candidate for unassigned projects",
    projects: [
      { name: "Kennebunk Commons", role: "primary" },
      { name: "Freeport Townhomes", role: "primary" },
    ],
  },
];

export const reasonOptions = [
  { id: "reassign", icon: "🔄", label: "Permanent reassignment" },
  { id: "vacation", icon: "🌴", label: "Inspector on vacation / leave" },
  { id: "departed", icon: "🚪", label: "Inspector no longer with CSC" },
  { id: "workload", icon: "⚖️", label: "Workload rebalancing" },
  { id: "geo", icon: "📍", label: "Geographic / proximity" },
];

export const notifyOptions = [
  {
    id: "notifyNewInspector",
    label: "Notify new inspector via email & in-app",
    defaultChecked: false,
  },
  {
    id: "notifyPrevInspector",
    label: "Notify previous inspector of reassignment",
    defaultChecked: false,
  },
  {
    id: "notifyLendingOfficer",
    label: "Notify lending officer at bank",
    defaultChecked: false,
  },
  { id: "notifyGc", label: "Notify GC / contractor", defaultChecked: false },
];

export const filterOptions = {
  inspector: [
    "All Inspectors",
    "R. Milley II",
    "T. Sullivan",
    "J. McLaughlin",
    "M. Bouchard",
    "Unassigned",
  ],
  type: ["All Types", "Residential", "Commercial"],
  status: ["All Statuses", "In Progress", "Pre-Construction"],
};
